import React, { Fragment } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button, Col, Descriptor, Form, Row, Submit } from "../..";
import { Search } from "../../Search";
import { StatusLabel } from "../../StatusLabel";
import { Title } from "../../Title";
import { Tooltip } from "../../Tooltip";
import { ArticleHeaderContext } from "../../hooks/articleHeaderContext";
import { useTranslation } from "../../hooks/useTranslation";
import { FormStateStatus } from "../../utils/FormStateStatus";
import parseChildren from "../../utils/parseChildren";
export function ArticleHeader({ title, titlePostText, subtitle, pageInfo, titleLevel = "h2", extra, create, children, filters, loading, id, isCompact = false, label, hideResults = false, tooltip, dataTestId, dataId, search, }) {
    let numberOfFilters = 0;
    const filterChildren = parseChildren(children);
    const hiddenChildren = () => filterChildren.filter((child) => child.props.hidden).length;
    if (filters) {
        numberOfFilters = filterChildren.length - hiddenChildren();
    }
    return (React.createElement(ArticleHeaderContext.Provider, { value: {
            loading,
            numberOfFilters,
            isCompact,
        } },
        React.createElement("div", { className: "article-header article-header--tms", id: id, "data-id": dataId, "data-testid": dataTestId },
            filters && (numberOfFilters > 1 || isCompact) && (React.createElement(Filters, { values: filters.values, onSubmit: filters.onSubmit, onCancel: filters.onCancel, loading: loading, applyHelpMessage: filters.applyHelpMessage }, children)),
            (title || extra || create || tooltip || search) && (React.createElement("div", { className: "article-header--heading" },
                title && (React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement(Title, { titleLevel: titleLevel, dataHook: "article-header--title" },
                        React.createElement(Fragment, null,
                            title,
                            " ",
                            pageInfo && !hideResults && `(${pageInfo.totalRecords})`)),
                    tooltip && (React.createElement("div", { className: "ml-2" },
                        React.createElement(Descriptor, { message: tooltip, placement: "top", icon: "question-sign", color: "#757575" }))),
                    titlePostText)),
                label && (React.createElement(StatusLabel, { ...label, dataHook: "article-header--title" })),
                search && (React.createElement("div", { className: "article-header--search" },
                    React.createElement(Search, { ...search }))),
                (extra || filters || create) && (React.createElement("div", { className: "article-header-heading--extra" },
                    filters && numberOfFilters === 1 && !isCompact && (React.createElement(InlineFilter, { values: filters.values, loading: loading }, children)),
                    extra,
                    create &&
                        (create.tooltip ? (React.createElement(Tooltip, { tooltipId: uuidv4(), content: create.tooltip, placement: create.tooltipPlacement },
                            React.createElement(Button, { type: "primary", disabled: true, onClick: () => [], label: create.label, id: create.id, dataHook: "article-header--create-button" }))) : (React.createElement(Button, { type: "primary", label: create.label, onClick: create.onClick, disabled: create.disabled, id: create.id, dataHook: "article-header--create-button" }))))))),
            subtitle && React.createElement("div", { className: "article-header--subtitle" }, subtitle)),
        create?.saveState && (React.createElement(FormStateStatus, { saveState: create.saveState, messages: create.messages }))));
}
function Filters({ values, onSubmit, onCancel, children, loading, id, applyHelpMessage, }) {
    const t = useTranslation();
    return (React.createElement("div", { className: "filters" },
        React.createElement(Form, { values: values, onSubmit: onSubmit, disabled: loading },
            React.createElement(Row, null, children),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("div", { className: "pull-right" },
                        onCancel && (React.createElement("div", { style: { display: "inline-block", marginRight: 8 } },
                            React.createElement(Button, { label: t("Clear Filters"), onClick: onCancel, id: id && `${id}__clear`, disabled: loading }))),
                        applyHelpMessage ? (React.createElement(Tooltip, { content: applyHelpMessage, tooltipId: uuidv4(), glyphicon: "info-sign" },
                            React.createElement(Submit, { inline: true, label: t("Apply Filters"), id: id && `${id}__apply-filters` }))) : (React.createElement(Submit, { inline: true, label: t("Apply Filters"), id: id && `${id}__apply-filters` }))))))));
}
function InlineFilter({ values, children, loading }) {
    return (React.createElement("div", { className: "filters--inline" },
        React.createElement(Form, { values: values, disabled: loading },
            React.createElement(Row, null, children))));
}
